import React from 'react';
import styled from "styled-components";

export const BusinessStatus = styled( ({status='published', ...props}) => {
    return <span {...props}>{status === 'draft' ? 'Draft' : ''}</span>
})``;